import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fillTabContentInNewStaticScreenEpic } from './fillTabContentInNewStaticScreenEpic';
import { fillTabContentInNewStaticScreenFailedEpic } from './fillTabContentInNewStaticScreenFailedEpic';

export const staticScreenTabContentEpic = () =>
  withAppCrashIfException(
    'staticScreenTabContent',
    combineEpics(
      fillTabContentInNewStaticScreenEpic(), // no async, should be a thunk
      fillTabContentInNewStaticScreenFailedEpic(), // no async, should be a thunk
    ),
  );
